import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import PackDetails from './Components/PacksPages/PackDetails';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import PacksProvider from './Components/Context/PacksContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function PackDetailsRoute() {
    return (
        <UserInfoProvider>
            <PacksProvider>
                <MedicalContextProvider>
                    <div className="PackDetailsRoutePage">
                        <div className="PackDetailsRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="PackDetailsRoute">
                            <PackDetails/>
                        </div>
                        {/*<div className="PackDetailsRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </PacksProvider>
        </UserInfoProvider>
    );
}

export default PackDetailsRoute;